import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import ICONS from "../../../assets/Icons";
import { toast_position } from "../../../redux/features/Settings/Authorization";
import {
  ownerListViewAllAcc,
  resetOwnerBalance,
} from "../../../redux/features/owner/ownerAllVerification/ownerAllVerification";
import TEXT from "../../../utils/globalText";
import { globalTextFormat } from "../../../utils/globalTextFormat";
import SVGComponent from "../../_utils/SVGComponent";
import ConfidentialCard from "../../_utils/TransactionCommonComponents/ConfidentialCard";
import DynamicAdditionalFields from "../../_utils/TransactionCommonComponents/DynamicAdditionalFields";
import NameFieldCard from "../../_utils/TransactionCommonComponents/NameFieldCard";
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import UniversalRefreshToast from "../../_utils/UniversalRefreshToast";
import "./index.css";
import CommonToast from "../../_utils/CommonToast";
import CommonLayout from "../../_utils/CommonLayout";

const ScheduleInternalTxnSelectAccounts = (props) => {
  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const dispatch = useDispatch();
  const dateRef = useRef(null);
  const dropdownRefs = useRef(null);
  const [dropdowns, setDropdowns] = useState({});

  const { beneTransCategories } = useSelector(
    (state) => state.beneAllVerification,
  );
  const {
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
    createTransactionBankRefreshData,
  } = useSelector((state) => state.ownerAllVerification);

  const handleCloseModal = () => {
    props.setIsModalOpen(false);
  };

  const handleOwnerSelection = (name, acc, ifsc, logo, ownerId) => {
    props?.setTxnPayLoad((prev) => ({
      ...prev,
      ownerId,
      ownerAccountName: name,
      ownerBankAccountNo: acc,
      ownerBankIFSC: ifsc,
      ownerBankLogo: logo,
    }));
  };
  const handleAccountSelection = async (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
    isInternal,
  ) => {
    let data1 = await dispatch(
      ownerListViewAllAcc({
        bank_account_no: accountNumber,
        pan: panNo,
        ifsc: ifsc,
      }),
    );

    props.setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      isDestinationOwnerActive: isInternal,
      destinationAccountBalance:
        data1?.payload?.owner_accounts[0]?.owner_account_balance,
      destinationAcountOwnerId: data1?.payload?.owner_accounts[0]?.id,
      destinationAcountOwnerLastUpdated:
        data1?.payload?.owner_accounts[0]
          ?.owner_account_balance_last_fetched_at_in_words,
      selectedCategory:
        prev.selectedCategory ||
        beneTransCategories?.categories?.filter((fil) => {
          return fil.name === "Internal";
        })[0],
      mergeCategory: prev.mergeCategory?.length
        ? prev.mergeCategory
        : beneTransCategories?.categories?.filter((fil) => {
            return fil.name === "Internal";
          })[0]?.configuration?.data,
    }));
    handleCloseModal();
  };

  useEffect(() => {
    if (props?.activeStep === 0 && props?.selectedCategory === null) {
      props?.setNextButtonEnabled(true);
    } else if (props?.activeStep === 0 && props?.selectedCategory !== null) {
      props?.setNextButtonEnabled(false);
    }
  }, [props?.activeStep]);

  useEffect(() => {
    if (props?.refreshId === props?.txnPayLoad?.destinationAcountOwnerId) {
      if (createTransactionBankRefreshLoading) {
        toast.dismiss();
        UniversalRefreshToast();
      } else if (createTransactionBankRefreshData?.status) {
        toast.dismiss();
        CommonToast({
          text: "Balance refreshed successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else if (
        createTransactionBankRefreshError &&
        !createTransactionBankRefreshLoading
      ) {
        toast.dismiss();
        CommonToast({
          text: createTransactionBankRefreshError,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
      if (createTransactionBankRefreshData) {
        props?.setTxnPayLoad({
          ...props?.txnPayLoad,
          destinationAccountBalance:
            createTransactionBankRefreshData?.owner_accounts[0]
              ?.owner_account_balance,
          destinationAcountOwnerLastUpdated:
            createTransactionBankRefreshData?.owner_accounts[0]
              ?.owner_account_balance_last_fetched_at_in_words,
        });
      }
    }
    return () => {
      dispatch(resetOwnerBalance());
    };
  }, [
    createTransactionBankRefreshData,
    createTransactionBankRefreshLoading,
    createTransactionBankRefreshError,
  ]);

  useEffect(() => {
    const handleClickOutside2 = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        let obj = {
          ...dropdowns,
          isOpen: false,
        };
        setDropdowns(obj);
      }
    };

    document.addEventListener("mousedown", handleClickOutside2);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside2);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dateRef.current && !dateRef.current.contains(event.target)) {
        props?.setShowDatePickerCal(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (!props?.additionalData) return;
    if (!props?.txnPayLoad?.selectedCategory?.configuration?.data) return;

    const storeData = props.txnPayLoad.selectedCategory.configuration.data.map(
      (val) => {
        const dataValue = props.additionalData[val.name];

        if (dataValue === undefined || dataValue === "") {
          switch (val.data_type) {
            case "multi_select_list":
              return { ...val, value: [] };

            case "toggle":
              return { ...val, value: false };

            case "quantity":
              return { ...val, value: 0 };

            case "hyperlink":
            case "upload":
            case "time":
              return { ...val, value: "" };

            case "date_range": {
              if (val.mandatory !== "Y") {
                const { value, ...rest } = val;
                return rest;
              }

              return {
                ...val,
                value: {
                  start_date: dataValue?.start_date || "",
                  end_date: dataValue?.end_date || "",
                },
              };
            }

            case "from_year_to_year": {
              if (val.mandatory !== "Y") {
                const { value, ...rest } = val;
                return rest;
              }

              return {
                ...val,
                value: {
                  from: dataValue?.from ?? "",
                  to: dataValue?.to ?? "",
                },
              };
            }

            default:
              return val.mandatory !== "Y" ? { ...val, value: "" } : val;
          }
        }

        switch (val.data_type) {
          case "numeric": {
            const num = Number(dataValue);
            return {
              ...val,
              value: isNaN(num) ? "" : num,
            };
          }

          case "toggle":
            return {
              ...val,
              value: dataValue === true,
            };

          case "multi_select_list":
            return {
              ...val,
              value: Array.isArray(dataValue) ? dataValue : [],
            };

          case "date_range":
            return {
              ...val,
              value: {
                start_date: dataValue?.start_date || "",
                end_date: dataValue?.end_date || "",
              },
            };

          case "month_year": {
            if (typeof dataValue === "string") {
              return { ...val, value: dataValue };
            }

            if (dataValue?.month && dataValue?.year) {
              const monthIndex = months.indexOf(dataValue.month) + 1;

              const formattedMonth = String(monthIndex).padStart(2, "0");

              return {
                ...val,
                value: `${formattedMonth}/${dataValue.year}`,
              };
            }

            return { ...val, value: "" };
          }

          case "from_year_to_year": {
            const from =
              dataValue?.from !== undefined && dataValue?.from !== null
                ? Number(dataValue.from)
                : "";

            const to =
              dataValue?.to !== undefined && dataValue?.to !== null
                ? Number(dataValue.to)
                : "";

            return {
              ...val,
              value: {
                from: isNaN(from) ? "" : from,
                to: isNaN(to) ? "" : to,
              },
            };
          }

          case "time":
            return {
              ...val,
              value: dataValue || "",
            };

          default:
            return {
              ...val,
              value: dataValue,
            };
        }
      },
    );

    props.setTxnPayLoad((prev) => ({
      ...prev,
      mergeCategory: storeData,
    }));
  }, [props.additionalData, props.txnPayLoad.selectedCategory]);

  return (
    <>
      <div
        className={`w-width-full px-padding-md lg:px-padding-base pb-padding-md pt-padding-lg overflow-y-auto`}
        style={{ scrollbarWidth: "none" }}
      >
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <SourceDestinationAccountDetail
              type="source"
              modalOpen={props.openOwner}
              setModalOpen={props.setOpenOwner}
              txnPayLoad={props.txnPayLoad}
              setTxnPayLoad={props.setTxnPayLoad}
              shouldShowAssociatedAccounts={false}
              handleOnAccountSelection={handleOwnerSelection}
            />
          </div>

          <div className="flex flex-col gap-gap-md w-width-full">
            <div
              className={`w-width-full  lg:max-w-[var(--create-box-width)] ${
                !props?.txnPayLoad?.ownerBankAccountNo
                  ? "opacity-light-opacity pointer-events-none"
                  : "opacity-base-opacity"
              }`}
            >
              <SourceDestinationAccountDetail
                flow={"internalTxn"}
                type="destination"
                modalOpen={props.isModalOpen}
                setModalOpen={props.setIsModalOpen}
                txnPayLoad={props.txnPayLoad}
                setTxnPayLoad={props.setTxnPayLoad}
                shouldShowAssociatedAccounts={false}
                handleOnAccountSelection={handleAccountSelection}
              />
            </div>
          </div>

          <div className="flex flex-col gap-gap-md w-width-full  lg:max-w-[var(--create-box-width)]">
            <NameFieldCard
              title={TEXT?.SCHEDULE_NAME}
              placeholder={TEXT?.SCHEDULE_CREATE_PLACEHOLDER_NAME}
              fieldName="schedule_name"
              minLength={5}
              mode="strict"
              value={props?.txnPayLoad?.scheduled_name}
              onChange={(val) =>
                props?.setTxnPayLoad({
                  ...props?.txnPayLoad,
                  scheduled_name: val,
                })
              }
            />

            <ConfidentialCard
              icon={ICONS.CONFIDENTIAL_TRANSACTION}
              title={TEXT?.CREATE_AS_CONFIDENTIAL}
              note={TEXT?.CONFIDENTIAL_SCHEDULE_TRANSACTION_NOTE}
              toggleState={props?.isConfidential}
              onToggle={() => props?.setIsConfidential(!props?.isConfidential)}
            />
          </div>
        </CommonLayout>
      </div>
    </>
  );
};

export default ScheduleInternalTxnSelectAccounts;
